module.exports = function () {
    return {
        restrict: 'E',
        template: require('./login-navigation-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/login/login-navigation-directive.js
 **/